/* unplugin-vue-components disabled */import script from "./orderDetail.vue?vue&type=script&setup=true&lang=ts"
export * from "./orderDetail.vue?vue&type=script&setup=true&lang=ts"

import "./orderDetail.vue?vue&type=style&index=0&id=393a554f&scoped=true&lang=less"

import exportComponent from "/data/jenkins/workspace/infra_PayAdminWeb/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-393a554f"]])

export default __exports__